module.exports = __webpack_public_path__ + "img/gy6.70706df0.png";